<div class="menu-categories-container">
    <div class="menu-category-container">
        <div *ngFor="let menuOption of selectedMenuOptions; let i = index">
            <app-full-menu-option [menuOption]="menuOption" [shouldLoadOption]="(selectedMenuOptions.length==i+1)" [selectedCategoryName]="selectedCategory">
            </app-full-menu-option>
        </div>
    </div>
</div>